<template><svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><path d="M14 13h2v8h-2z"/><circle cx="15" cy="10" r="1.25"/></svg></template>